export const useDeviceMotion = () => {
  const requestPermission = () => {
    if (typeof DeviceMotionEvent === 'undefined') return;

    (
      DeviceMotionEvent as DeviceMotionEventWithPermission
    ).requestPermission?.();
  };

  return { requestPermission };
};
